export const formTitles = {
  ADDITIONAL_INSURANCE: 'Additional Health Insurance',
  BENEFIT_AMOUNTS: 'Confirming Benefit Amounts for a provider quote',
  COVERAGE: 'Interacting with my provider about my coverage',
  EXPENSE_QUESTION: 'General question about an expense',
  IMPROVE_SEARCH_RESULTS: 'Improve search results',
  INVOICE: 'Getting an itemized invoice from my provider',
  PROVIDER_PLA: 'Finding a provider for upcoming care',
  OTHER: 'Other',
  REQUEST_FORM: 'Request Form',
  REQUEST_TYPES: 'Request type options',
  PHARMACY_PLA: 'Finding a pharmacy to fill my prescription',
  PRE_CHECKED_PROVIDERS: 'What kind of care do you need?',
  SURGERY_SUPPORT: 'Getting a surgery or procedure',
  SURGERY_SUPPORT_CARDS: 'Getting a surgery or procedure ',
}
